import React, { Component } from 'react';
import "./WidgetDescription.scss";

class WidgetDescription extends Component {
  render() {
    const _this$props = this.props,
          description = _this$props.description,
          trending = _this$props.trending;

    if (!description) {
      return false;
    }

    return React.createElement("p", {
      className: "admin-widget__description",
      "data-trending": trending
    }, description);
  }

}

export default WidgetDescription;